<mat-calendar
	[startAt]="startAt"
	[dateClass]="getDateClass"
	[selected]="hoverRangeValue ? hoverRangeValue : null"
	(viewChanged)="onViewChanged($event)"
>
</mat-calendar>
